export function isRootEvent(event){
    return event && event.type === 'Used' && event.target === 'game'
}